export const AWN_PRIMARY_COLOR = '#172983';

export const AWN_SECONDARY_COLOR = '#068945';
export const AWN_SECONDARY_COLOR_LIGHT = '#76be99';

export const CHAT_BACKGROUND_COLOR = '#f9f8f7';